import React from 'react'
import image from '@loyal_images/products/placeholder.svg'

const Placeholder = props => <img src={image} alt='Ainda está carregando...' />
export default Placeholder



// WEBPACK FOOTER //
// ./src/features/ProductImage/Placeholder.js